import { Components, Theme } from '@mui/material';

const width = 22;
const thumbSize = 6;
const padding = 3;

const transformX = width - thumbSize - padding * 2;

export const MuiSwitch: Components<Omit<Theme, 'components'>>['MuiSwitch'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width,
      height: 12,
      padding: 0,
      '& .MuiSwitch-switchBase': {
        padding,
        transitionDuration: '300ms',
        '&.Mui-checked': {
          transform: `translateX(${transformX}px)`,
          '& + .MuiSwitch-track': {
            backgroundColor: theme.palette.surface.onSurfaceVar,
            opacity: 1,
          },
        },
      },
      '& .MuiSwitch-thumb': {
        width: thumbSize,
        height: thumbSize,
        color: theme.palette.surface.surface,
      },
      '& .MuiSwitch-track': {
        backgroundColor: theme.palette.surface.onSurfaceVar,
        opacity: 1,
      },
    }),
  },
};
